// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SKU Master (sku-management) — list + form shell */
.sku-mgmt-master-list-card {
  border-radius: 0.5rem;
}

.sku-list-shell {
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(30, 57, 145, 0.06);
  font-family: "Montserrat", sans-serif;
}

.sku-list-shell .sku-list-header {
  background: #fff;
  border-bottom: 1px solid #eef2f7;
  padding: 14px 16px 12px;
}

.sku-list-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.sku-list-title {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.sku-list-title-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #e4eef7;
  color: #1e71bb;
  font-size: 16px;
}

.sku-list-title h5 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: #0f172a;
}

.sku-list-title p {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748b;
}

.sku-list-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.sku-list-search {
  width: 280px;
  height: 34px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.sku-list-search:focus-within {
  border-color: #93b7e0;
  box-shadow: 0 0 0 3px rgba(30, 113, 187, 0.12);
}

.sku-list-search .input-group-text,
.sku-list-search .form-control {
  border: 0;
  background: transparent;
  box-shadow: none !important;
  font-size: 12px;
}

.sku-list-search .input-group-text {
  color: #94a3b8;
  padding-right: 4px;
}

.sku-list-btn.btn {
  height: 34px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 14px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  transition: background 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.sku-list-btn-primary.btn,
.sku-list-btn-primary.btn:hover,
.sku-list-btn-primary.btn:focus,
.sku-list-btn-primary.btn:active {
  color: #fff;
  border: 0;
  background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));
  box-shadow: 0 1px 2px rgba(43, 57, 145, 0.2), 0 6px 14px rgba(30, 113, 187, 0.22);
}

.sku-list-btn-primary.btn:hover {
  transform: translateY(-1px);
  opacity: 1;
}

.sku-list-btn-soft.btn,
.sku-list-btn-soft.btn:focus,
.sku-list-btn-soft.btn:active {
  color: #2b3991;
  border: 0;
  background: #eef3fb;
  box-shadow: none;
}

.sku-list-btn-soft.btn:hover {
  color: #2b3991;
  background: #e2ebf8;
}

.sku-list-filters .form-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b !important;
  margin-bottom: 4px !important;
}

.sku-list-filters .form-select {
  height: 34px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 12px;
  color: #0f172a;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.sku-list-filters .form-select:focus {
  border-color: #93b7e0;
  box-shadow: 0 0 0 3px rgba(30, 113, 187, 0.12);
}

.sku-list-clear.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #dc2626;
  text-decoration: none;
}

.sku-list-clear.btn:hover {
  color: #b91c1c;
  background: #fef2f2;
}

.sku-list-shell .sku-list-body {
  padding: 12px 16px 16px;
}

.sku-list-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
}

.sku-list-note {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  font-size: 12px;
  color: #64748b;
}

.sku-list-shell .sku-list-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 16px;
  background: #fbfcfe;
  border-top: 1px solid #eef2f7;
}

.sku-list-footer-meta {
  font-size: 12px;
  color: #64748b;
}

.sku-list-footer-meta strong {
  color: #0f172a;
  font-weight: 600;
}

.sku-list-footer-hint {
  margin-left: 8px;
  padding-left: 8px;
  border-left: 1px solid #e2e8f0;
  color: #94a3b8;
}

.sku-list-pager {
  display: inline-flex;
  gap: 6px;
}

.sku-list-pager button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 30px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  transition: color 0.18s ease, border-color 0.18s ease, background 0.18s ease;
}

.sku-list-pager button:hover:not(:disabled) {
  color: #1e71bb;
  border-color: #c9d9ee;
  background: #f8fbff;
}

.sku-list-pager button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

@media (max-width: 767.98px) {
  .sku-list-search {
    width: 100%;
  }
}

/* Create SKU form: vertical rhythm via flex */
.create-sku-form {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  gap: 0;
  min-height: 0;
}

/* Stepper must not shrink — prevents form body from overlapping step icons */
.create-sku-form .sku-mgmt-master-stepper {
  flex: 0 0 auto;
  position: relative;
  z-index: 2;
  background: var(--bs-body-bg);
  margin-bottom: 0.5rem;
}

.create-sku-form-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.create-sku-form-scroll .sku-form-tab-panel,
.create-sku-form-scroll .create-sku-form-body {
  overflow: visible;
  min-height: auto;
}

/* TabWrapper applies \`.tab-content .card { height: calc(100% - 10px) }\` globally */
.tab-content .sku-mgmt-create-shell {
  height: calc(100vh - 7.5rem);
  max-height: calc(100vh - 7.5rem);
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tab-content .sku-mgmt-create-shell > .card-header,
.tab-content .sku-mgmt-create-shell > nav {
  flex: 0 0 auto;
}

.tab-content .create-sku-form .card,
.tab-content .sku-mgmt-create-shell .card-body .card {
  height: auto !important;
  max-height: none !important;
}

.create-sku-form fieldset.sku-form-readonly {
  pointer-events: none;
}

.create-sku-form fieldset.sku-form-readonly .form-control,
.create-sku-form fieldset.sku-form-readonly .form-select,
.create-sku-form fieldset.sku-form-readonly textarea {
  background-color: var(--bs-light);
  opacity: 1;
  cursor: default;
}

.create-sku-form .row.g-3 {
  --bs-gutter-x: 0.65rem;
  --bs-gutter-y: 0.65rem;
}

.create-sku-form-scroll > fieldset {
  display: block;
  min-height: auto;
  margin: 0;
  padding: 0;
  border: 0;
}

.create-sku-form-sticky {
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem 0.85rem;
  margin: 0;
  padding: 0.75rem 0 0;
  border-top: 1px solid var(--bs-border-color-translucent);
  background: var(--bs-body-bg);
}

.sku-mgmt-create-shell {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.sku-mgmt-create-shell > .card-body,
.sku-mgmt-create-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0.75rem 1rem;
}

@media (max-width: 575.98px) {
  .create-sku-form-sticky {
    flex-direction: column;
    align-items: stretch;
  }

  .create-sku-form-sticky-actions {
    min-width: 100%;
    justify-content: center;
  }
}

.create-sku-form-sticky-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.35rem 0.5rem;
  flex: 1 1 auto;
  min-width: min(100%, 16rem);
}

@media (min-width: 992px) {
  .create-sku-form-sticky-actions {
    flex: 0 1 auto;
    justify-content: flex-end;
  }
}

/* List + create shell: icon badge beside page title */
.sku-mgmt-page-title-icon {
  width: 2.35rem;
  height: 2.35rem;
  background: rgba(var(--bs-primary-rgb), 0.1);
  color: var(--bs-primary);
  font-size: 1.1rem;
}

.sku-mgmt-master-list-card .table-hover tbody tr:hover {
  background-color: rgba(13, 110, 253, 0.06);
}

.sku-mgmt-master-empty {
  padding: 3rem 1.5rem;
  text-align: center;
  color: var(--bs-secondary-color);
}

.sku-mgmt-master-empty i {
  font-size: 2.5rem;
  opacity: 0.35;
}

.sku-mgmt-master-stepper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.35rem 0.65rem;
  padding: 0.5rem 0.15rem 0.65rem;
  border-bottom: 1px solid var(--bs-border-color);
}

/* Icon stepper: column steps (icon + label), horizontal strip */
.sku-mgmt-master-stepper--icons {
  flex-wrap: nowrap;
  align-items: stretch;
  justify-content: flex-start;
  gap: clamp(0.2rem, 1vw, 0.65rem);
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0.55rem 0.2rem 0.65rem;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
}

.sku-mgmt-master-stepper .step {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0.3rem;
  flex: 0 0 auto;
  min-width: 4.1rem;
  max-width: 5.85rem;
  padding: 0.3rem 0.3rem;
  border-radius: 0.375rem;
  font-size: 0.6875rem;
  line-height: 1.15;
  color: var(--bs-secondary-color);
  transition: background-color 0.15s ease, color 0.15s ease;
}

.sku-mgmt-master-stepper--icons .step:hover:not(.active) {
  background-color: rgba(var(--bs-primary-rgb), 0.06);
}

.sku-mgmt-master-stepper--icons .step-label {
  display: block;
  width: 100%;
  text-align: center;
  white-space: normal;
  word-break: break-word;
}

.sku-mgmt-master-stepper .step.active {
  color: var(--bs-primary);
  font-weight: 600;
}

.sku-mgmt-master-stepper .step.done .step-dot {
  background: var(--bs-success);
  border-color: var(--bs-success);
  color: #fff;
}

.sku-mgmt-master-stepper .step-dot {
  width: 1.45rem;
  height: 1.45rem;
  border-radius: 50%;
  border: 2px solid var(--bs-border-color);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.62rem;
  line-height: 1;
}

.sku-mgmt-master-stepper--icons .step-dot {
  width: 2.125rem;
  height: 2.125rem;
  font-size: 1rem;
}

.sku-mgmt-master-stepper--icons .step-dot .bi {
  line-height: 1;
}

.sku-mgmt-master-stepper .step.active .step-dot {
  border-color: var(--bs-primary);
  background: var(--bs-primary-bg-subtle);
  color: var(--bs-primary);
}

@media (min-width: 1200px) {
  .sku-mgmt-master-stepper--icons {
    flex-wrap: wrap;
    justify-content: space-between;
    overflow-x: visible;
    gap: 0.35rem 0.5rem;
    padding-inline: 0.15rem;
  }

  .sku-mgmt-master-stepper--icons .step {
    flex: 1 1;
    min-width: 0;
    max-width: none;
    padding-inline: 0.25rem;
  }
}

.sku-mgmt-image-dropzone {
  border: 2px dashed var(--bs-border-color);
  border-radius: 0.5rem;
  padding: 1rem;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.sku-mgmt-image-dropzone:hover,
.sku-mgmt-image-dropzone.drag-active {
  border-color: var(--bs-primary);
  background: var(--bs-primary-bg-subtle);
}

.sku-mgmt-image-preview-card img {
  width: 100%;
  height: 120px;
  object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./src/pages/sku-management/sku-master/skuMaster.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gFAAgF;EAChF,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,SAAS;EACT,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8EAA8E;AAChF;;AAEA;;;;EAIE,WAAW;EACX,SAAS;EACT,+EAA+E;EAC/E,iFAAiF;AACnF;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;;;EAGE,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4EAA4E;AAC9E;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,MAAM;EACN,aAAa;AACf;;AAEA,6EAA6E;AAC7E;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mFAAmF;AACnF;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,iCAAiC;EACjC,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,wDAAwD;EACxD,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE;IACE,cAAc;IACd,yBAAyB;EAC3B;AACF;;AAEA,sDAAsD;AACtD;EACE,cAAc;EACd,eAAe;EACf,4CAA4C;EAC5C,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,+BAA+B;EAC/B,+CAA+C;AACjD;;AAEA,gEAAgE;AAChE;EACE,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,SAAW;IACX,YAAY;IACZ,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;;EAEE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB","sourcesContent":["/* SKU Master (sku-management) — list + form shell */\n.sku-mgmt-master-list-card {\n  border-radius: 0.5rem;\n}\n\n.sku-list-shell {\n  border-radius: 14px;\n  overflow: hidden;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(30, 57, 145, 0.06);\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.sku-list-shell .sku-list-header {\n  background: #fff;\n  border-bottom: 1px solid #eef2f7;\n  padding: 14px 16px 12px;\n}\n\n.sku-list-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.sku-list-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.sku-list-title-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: #e4eef7;\n  color: #1e71bb;\n  font-size: 16px;\n}\n\n.sku-list-title h5 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: #0f172a;\n}\n\n.sku-list-title p {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.sku-list-actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.sku-list-search {\n  width: 280px;\n  height: 34px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #fff;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.sku-list-search:focus-within {\n  border-color: #93b7e0;\n  box-shadow: 0 0 0 3px rgba(30, 113, 187, 0.12);\n}\n\n.sku-list-search .input-group-text,\n.sku-list-search .form-control {\n  border: 0;\n  background: transparent;\n  box-shadow: none !important;\n  font-size: 12px;\n}\n\n.sku-list-search .input-group-text {\n  color: #94a3b8;\n  padding-right: 4px;\n}\n\n.sku-list-btn.btn {\n  height: 34px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 14px;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  transition: background 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;\n}\n\n.sku-list-btn-primary.btn,\n.sku-list-btn-primary.btn:hover,\n.sku-list-btn-primary.btn:focus,\n.sku-list-btn-primary.btn:active {\n  color: #fff;\n  border: 0;\n  background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));\n  box-shadow: 0 1px 2px rgba(43, 57, 145, 0.2), 0 6px 14px rgba(30, 113, 187, 0.22);\n}\n\n.sku-list-btn-primary.btn:hover {\n  transform: translateY(-1px);\n  opacity: 1;\n}\n\n.sku-list-btn-soft.btn,\n.sku-list-btn-soft.btn:focus,\n.sku-list-btn-soft.btn:active {\n  color: #2b3991;\n  border: 0;\n  background: #eef3fb;\n  box-shadow: none;\n}\n\n.sku-list-btn-soft.btn:hover {\n  color: #2b3991;\n  background: #e2ebf8;\n}\n\n.sku-list-filters .form-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b !important;\n  margin-bottom: 4px !important;\n}\n\n.sku-list-filters .form-select {\n  height: 34px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 12px;\n  color: #0f172a;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.sku-list-filters .form-select:focus {\n  border-color: #93b7e0;\n  box-shadow: 0 0 0 3px rgba(30, 113, 187, 0.12);\n}\n\n.sku-list-clear.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 34px;\n  padding: 0 10px;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #dc2626;\n  text-decoration: none;\n}\n\n.sku-list-clear.btn:hover {\n  color: #b91c1c;\n  background: #fef2f2;\n}\n\n.sku-list-shell .sku-list-body {\n  padding: 12px 16px 16px;\n}\n\n.sku-list-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 320px;\n}\n\n.sku-list-note {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 10px;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.sku-list-shell .sku-list-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #fbfcfe;\n  border-top: 1px solid #eef2f7;\n}\n\n.sku-list-footer-meta {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.sku-list-footer-meta strong {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.sku-list-footer-hint {\n  margin-left: 8px;\n  padding-left: 8px;\n  border-left: 1px solid #e2e8f0;\n  color: #94a3b8;\n}\n\n.sku-list-pager {\n  display: inline-flex;\n  gap: 6px;\n}\n\n.sku-list-pager button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 30px;\n  padding: 0 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n  transition: color 0.18s ease, border-color 0.18s ease, background 0.18s ease;\n}\n\n.sku-list-pager button:hover:not(:disabled) {\n  color: #1e71bb;\n  border-color: #c9d9ee;\n  background: #f8fbff;\n}\n\n.sku-list-pager button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n@media (max-width: 767.98px) {\n  .sku-list-search {\n    width: 100%;\n  }\n}\n\n/* Create SKU form: vertical rhythm via flex */\n.create-sku-form {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  gap: 0;\n  min-height: 0;\n}\n\n/* Stepper must not shrink — prevents form body from overlapping step icons */\n.create-sku-form .sku-mgmt-master-stepper {\n  flex: 0 0 auto;\n  position: relative;\n  z-index: 2;\n  background: var(--bs-body-bg);\n  margin-bottom: 0.5rem;\n}\n\n.create-sku-form-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.create-sku-form-scroll .sku-form-tab-panel,\n.create-sku-form-scroll .create-sku-form-body {\n  overflow: visible;\n  min-height: auto;\n}\n\n/* TabWrapper applies `.tab-content .card { height: calc(100% - 10px) }` globally */\n.tab-content .sku-mgmt-create-shell {\n  height: calc(100vh - 7.5rem);\n  max-height: calc(100vh - 7.5rem);\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.tab-content .sku-mgmt-create-shell > .card-header,\n.tab-content .sku-mgmt-create-shell > nav {\n  flex: 0 0 auto;\n}\n\n.tab-content .create-sku-form .card,\n.tab-content .sku-mgmt-create-shell .card-body .card {\n  height: auto !important;\n  max-height: none !important;\n}\n\n.create-sku-form fieldset.sku-form-readonly {\n  pointer-events: none;\n}\n\n.create-sku-form fieldset.sku-form-readonly .form-control,\n.create-sku-form fieldset.sku-form-readonly .form-select,\n.create-sku-form fieldset.sku-form-readonly textarea {\n  background-color: var(--bs-light);\n  opacity: 1;\n  cursor: default;\n}\n\n.create-sku-form .row.g-3 {\n  --bs-gutter-x: 0.65rem;\n  --bs-gutter-y: 0.65rem;\n}\n\n.create-sku-form-scroll > fieldset {\n  display: block;\n  min-height: auto;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.create-sku-form-sticky {\n  flex: 0 0 auto;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem 0.85rem;\n  margin: 0;\n  padding: 0.75rem 0 0;\n  border-top: 1px solid var(--bs-border-color-translucent);\n  background: var(--bs-body-bg);\n}\n\n.sku-mgmt-create-shell {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.sku-mgmt-create-shell > .card-body,\n.sku-mgmt-create-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 0.75rem 1rem;\n}\n\n@media (max-width: 575.98px) {\n  .create-sku-form-sticky {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .create-sku-form-sticky-actions {\n    min-width: 100%;\n    justify-content: center;\n  }\n}\n\n.create-sku-form-sticky-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.35rem 0.5rem;\n  flex: 1 1 auto;\n  min-width: min(100%, 16rem);\n}\n\n@media (min-width: 992px) {\n  .create-sku-form-sticky-actions {\n    flex: 0 1 auto;\n    justify-content: flex-end;\n  }\n}\n\n/* List + create shell: icon badge beside page title */\n.sku-mgmt-page-title-icon {\n  width: 2.35rem;\n  height: 2.35rem;\n  background: rgba(var(--bs-primary-rgb), 0.1);\n  color: var(--bs-primary);\n  font-size: 1.1rem;\n}\n\n.sku-mgmt-master-list-card .table-hover tbody tr:hover {\n  background-color: rgba(13, 110, 253, 0.06);\n}\n\n.sku-mgmt-master-empty {\n  padding: 3rem 1.5rem;\n  text-align: center;\n  color: var(--bs-secondary-color);\n}\n\n.sku-mgmt-master-empty i {\n  font-size: 2.5rem;\n  opacity: 0.35;\n}\n\n.sku-mgmt-master-stepper {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.35rem 0.65rem;\n  padding: 0.5rem 0.15rem 0.65rem;\n  border-bottom: 1px solid var(--bs-border-color);\n}\n\n/* Icon stepper: column steps (icon + label), horizontal strip */\n.sku-mgmt-master-stepper--icons {\n  flex-wrap: nowrap;\n  align-items: stretch;\n  justify-content: flex-start;\n  gap: clamp(0.2rem, 1vw, 0.65rem);\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 0.55rem 0.2rem 0.65rem;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n}\n\n.sku-mgmt-master-stepper .step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.3rem;\n  flex: 0 0 auto;\n  min-width: 4.1rem;\n  max-width: 5.85rem;\n  padding: 0.3rem 0.3rem;\n  border-radius: 0.375rem;\n  font-size: 0.6875rem;\n  line-height: 1.15;\n  color: var(--bs-secondary-color);\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.sku-mgmt-master-stepper--icons .step:hover:not(.active) {\n  background-color: rgba(var(--bs-primary-rgb), 0.06);\n}\n\n.sku-mgmt-master-stepper--icons .step-label {\n  display: block;\n  width: 100%;\n  text-align: center;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.sku-mgmt-master-stepper .step.active {\n  color: var(--bs-primary);\n  font-weight: 600;\n}\n\n.sku-mgmt-master-stepper .step.done .step-dot {\n  background: var(--bs-success);\n  border-color: var(--bs-success);\n  color: #fff;\n}\n\n.sku-mgmt-master-stepper .step-dot {\n  width: 1.45rem;\n  height: 1.45rem;\n  border-radius: 50%;\n  border: 2px solid var(--bs-border-color);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.62rem;\n  line-height: 1;\n}\n\n.sku-mgmt-master-stepper--icons .step-dot {\n  width: 2.125rem;\n  height: 2.125rem;\n  font-size: 1rem;\n}\n\n.sku-mgmt-master-stepper--icons .step-dot .bi {\n  line-height: 1;\n}\n\n.sku-mgmt-master-stepper .step.active .step-dot {\n  border-color: var(--bs-primary);\n  background: var(--bs-primary-bg-subtle);\n  color: var(--bs-primary);\n}\n\n@media (min-width: 1200px) {\n  .sku-mgmt-master-stepper--icons {\n    flex-wrap: wrap;\n    justify-content: space-between;\n    overflow-x: visible;\n    gap: 0.35rem 0.5rem;\n    padding-inline: 0.15rem;\n  }\n\n  .sku-mgmt-master-stepper--icons .step {\n    flex: 1 1 0;\n    min-width: 0;\n    max-width: none;\n    padding-inline: 0.25rem;\n  }\n}\n\n.sku-mgmt-image-dropzone {\n  border: 2px dashed var(--bs-border-color);\n  border-radius: 0.5rem;\n  padding: 1rem;\n  text-align: center;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.sku-mgmt-image-dropzone:hover,\n.sku-mgmt-image-dropzone.drag-active {\n  border-color: var(--bs-primary);\n  background: var(--bs-primary-bg-subtle);\n}\n\n.sku-mgmt-image-preview-card img {\n  width: 100%;\n  height: 120px;\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
